import React, {useEffect, useRef, useState } from "react";
import {
  Tabs,
  Button,
  Form,
  Input,
  DatePicker,
  Select,
  InputNumber,
  Icon,
  Row,
  Col,
} from "antd";
import SectionCard from "./SectionCard";
import _, { isEmpty } from "lodash";
import Checkbox_v2 from "./Checkbox_v2";
import SearchAddress_v2 from "./SearchAddress_v2";
import moment from "moment";
import ReusableDatePicker from "./ReusableDatePicker";
import Select_v2 from "./Select_v2";
import ReusableInput from "./ReusableInput";
import ItemsMeasure from "./ItemsMeasure";
import { OrgContext } from "../../context/OrgContext";
import CreateOrderAccessorial from "./CreateOrderAccessorial";
import { checkIsFilled } from "../../helpers/order_managemnt";
import { isAppointmentMandatoryOrg } from "../../helpers/appointmentOrgConfig";
import AddressLocationDetails from "../../components/orders/AddressLocationDetails";
import ServiceOptionsV2 from "./service_options_v2/ServiceOptionsV2";
import polygonActive from "../../../assets/images/triangle.svg";
import Documents from "./Documents";
import { setAccessorialResponse } from "../../helpers/orders";
import { updateLocationData } from "../../api/OrdersApi";

const { TabPane } = Tabs;
const { Option } = Select;

const MultistopOrder = (props) => {
  // const { selectedWarehouse ,currentOrg , form} = props;
  // const [stops, setStops] = useState(3);
  // const addStop = () => {
  //   setStops(stops + 1);
  // };

  const { 
    locObj,
    selectedWarehouse,
    accessorialDefs,
    accountAccessorial,
    config,
    currentOrder,
    haveMultipleLocations,
    displayComponents,
    getFieldDecorator,
    orderDetails,
    accountComponentAccessorial,
    driversData,
    orderTypeConfig,
    currentAccount,
    accountId,
    levelOfServices,
    warehouses,order,showAccessorial,showSidebySide,getDataRef,multistopLocationRef,
    accountConfig,getAccountComponentDefs,form,orgContext,handleUpdateWhStorage,locations,setLocation, 
    handleCreatePicsInfo,
    handleRemovePicsInfo,
    actionType,
    screenMode,
    msLos,
    isNew
   } = props;

  const { currentOrg, orgSettings } = orgContext
  const showAppointmentCheckbox = orgSettings?.show_appointment_checkbox_in_create_edit_order_screen == 'true';
  const locationRef = useRef(null);
  // const itemsInfoRef = useRef(null);
  const documentsRef = useRef(null)
  const [authorizeDetails, setAuthorizeDetails] = useState({});
  const [selectedButton, setSelectedButton] = useState(locObj.type_of_loc || "PICKUP");


  const [locationInfo, setLocationInfo] = useState({
    ...locObj,
    is_signature_required: locObj?.is_signature_required ?? true,
    is_form_required: locObj?.is_form_required ?? false,
    has_expedite: locObj?.appointment?.has_expedite ?? false,
  });

  const [orderAccessorials, setOrderAccessorials] = useState([]);
  const [disableExpedite, setDisableExpedite] = useState(true);


  const formRef = useRef(null);

const handleOnChangeDirect = (key, value) => {
  // Functional setState so this composes safely when called back-to-back
  // with other setLocationInfo calls in the same tick (e.g. the Expedite
  // wrapper fires handleOnChange + handleOnChangeDirect together; the
  // non-functional form would use a stale `locationInfo` closure and
  // clobber the first update — making the Expedite checkbox unclickable).
  setLocationInfo((prev) => ({
    ...prev,
    [key]: value,
  }));
};

const handleExpedite = (appointment) => {
  if(appointment?.appt_date){
    setDisableExpedite(false)
  }else{
    // handleOnChangeDirect("is_signature_required", false)
    //handleOnChange("has_expedite", "appointment", false)
  }
}

useEffect(() => {
  if (!(locObj.hasOwnProperty("id"))) {
    setLocationInfo({
      ...locationInfo,
      is_form_required:
        locObj.type_of_loc === "PICKUP"
          ? config?.is_shipper_pickup_form_mandatory === "true"
          : config?.is_shipper_delivery_form_mandatory === "true",
    });
  }
}, [config]);

useEffect(() => {
  const accessorials = locObj.accessorials || [];
  const authorizeDetails = {}
  const allowedIds = {};
  accountComponentAccessorial.forEach(
  (accessorial) => {
      const components = accessorial.components ? 
      accessorial.components.map(record => record.component_code)
      :
      [];
      allowedIds[accessorial.id] = [...components];
  })
  const orderAccessorialsInfo = setAccessorialResponse(
  accessorials,
  true,
  allowedIds,
  )
  orderAccessorialsInfo.forEach(rec => {
  if(!isEmpty(rec.authorized_by)){
      authorizeDetails[rec.accessorial_code] = {
      authorized_by: rec.authorized_by,
      authorization_code: rec.authorization_code,
      comments: rec.comments,
      is_modified: false,
      }
  }
  })
  setAuthorizeDetails(authorizeDetails)
  setOrderAccessorials(orderAccessorialsInfo)
}, [locObj.accessorials, accountComponentAccessorial, props?.displayComponents])

const updateLocData = () => {
  if(getDataRef) {
    // const itemsInfo = itemsInfoRef?.current &&  itemsInfoRef.current() || {};
    const obj = locationRef.current();
    const objWithAppointment = {
      ...obj,
      label_code: locationInfo.label_code,
      type_of_loc: locationInfo.type_of_loc,
      appointment: {
        ...obj.appointment,
        has_expedite: locationInfo.has_expedite || false
      }
    }
    getDataRef.current = () => ({
      ...objWithAppointment,
      ...(_.pick(locationInfo,['is_signature_required', 'has_expedite', "is_form_required", "form_id"])),
      accessorials : [...orderAccessorials],
      // order_items: itemsInfo.items || [] ,
      pictures : locObj.documents || [],
      // ...itemsInfo.measurements,
   })
  }
}
useEffect(() => {
  updateLocData()
},[locationInfo, documentsRef, getDataRef, orderAccessorials])

  const handleButtonClick = (buttonType, index) => {
    setSelectedButton(buttonType);
    setLocationInfo((prevLocation) => ({
      ...prevLocation,
      type_of_loc: buttonType,
      label_code: buttonType === "PICKUP" ? "R" : "D",
    }));
  };

  useEffect(() => {
    if (config?.allow_single_stop_multiple_stop === "true") {
      if (isNew && locObj?.type_of_loc === "PICKUP") {
        handleButtonClick("PICKUP")
      }
    }
  }, [config]);

  const handleOnChange = (key, subKey, value) => {
    setLocationInfo((prevLocation) => ({
        ...prevLocation,
        [subKey]: {
            ...prevLocation[subKey],
            [key]: value,
        },
    }));
};
const isRequired = location?.loc_order_sequence > 0 ? checkIsFilled(location) : true
const isFirstLoc = config?.allow_single_stop_multiple_stop === "true" ? (locationInfo?.loc_order_sequence === 0 && locations?.length > 1 ) : locationInfo?.loc_order_sequence === 0;
  return (
    
    <div>
            <Row gutter={16}>
                <Col xs={12}>
                  <div className="multiStopToggleButton" style={{marginLeft:'25px'}}>
                  <div
                    style={{ cursor: isFirstLoc ? 'not-allowed': 'pointer' }}
                    onClick={() =>
                      !isFirstLoc ? handleButtonClick("PICKUP") : undefined
                    }
                    className={`orderListIconContainer ${
                        (selectedButton === "PICKUP" ? "PICKUP" : "DELIVERY") ===
                      "PICKUP"
                        ? "buttonActive"
                        : "buttonDefaultColor"
                    }`}
                   
                  >
                    Pickup
                    {selectedButton === "PICKUP" && (
                      <img className="polygon" src={polygonActive} alt="^" />
                    )}
                  </div>
                  <div
                    style={{ cursor: isFirstLoc ? 'not-allowed': 'pointer' }}
                    onClick={() =>
                      !isFirstLoc  ? handleButtonClick("DELIVERY") : undefined
                    }
                    className={`driverMapIconContainer ${
                        (selectedButton === "DELIVERY" ? "DELIVERY" : "PICKUP") ===
                      "DELIVERY"
                        ? "buttonActive"
                        : "buttonDefaultColor"
                    }`}
                  >
                    Delivery
                    {selectedButton === "DELIVERY" && (
                      <img className="polygon" src={polygonActive} alt="^" />
                    )}
                  </div>
                </div>
                </Col>
                <Col xs={12} gutter={8} style={{ display: "flex", justifyContent: 'right' }}>
                    {/* MS top — service options use the new v2 design.
                        Bottom ServiceOptionsV2 in AddressLocationDetails is
                        gated off for MS so this is the only render. The
                        nested-write wrapper below keeps `has_expedite`
                        mirrored to the top-level key the save path reads
                        from (lines 154-164). */}
                    <ServiceOptionsV2
                      location={locationInfo}
                      typeOfLoc={selectedButton}
                      labelCode={locationInfo.label_code}
                      orderTypeCode={orderTypeConfig?.code}
                      expediteDisabled={disableExpedite}
                      isOrgSpecific={isAppointmentMandatoryOrg(currentOrg?.code)}
                      showAppointment={showAppointmentCheckbox}
                      defaultFormId={
                        selectedButton === "PICKUP"
                          ? config?.pickup_form_id || ""
                          : config?.form_id || ""
                      }
                      accountConfig={config}
                      onChangeDirect={handleOnChangeDirect}
                      onChangeNested={(key, parent, val) => {
                        handleOnChange(key, parent, val);
                        if (key === "has_expedite" && parent === "appointment") {
                          handleOnChangeDirect("has_expedite", val);
                        }
                      }}
                    />
                </Col>
              </Row>
              <div style={{display:"flex" , gap:"16px", justifyContent:"space-between", flexDirection:"column"}}>
              <Col className="ms-integrated-initial-card">
              <AddressLocationDetails
                    warehouses={warehouses}
                    orderTypeConfig={orderTypeConfig}
                    selectedWarehouse={selectedWarehouse ? selectedWarehouse : ""}
                    order={order}
                    locObj={locObj}
                    levelOfServices={levelOfServices}
                    getDataRef={locationRef}
                    accountComponentAccessorial={accessorialDefs?.accountAccData || []}  
                    showAccessorial={showAccessorial} //{!(orderDetails.label_code !== "MS" && locations?.length === 1)}  
                    config={config}   
                    haveMultipleLocations={haveMultipleLocations}    
                    displayComponents={accessorialDefs?.displayComponents || []}
                    getFieldDecorator={getFieldDecorator} 
                    showSidebySide={showSidebySide}    
                    accountConfig={accountConfig} 
                    getAccountComponentDefs={getAccountComponentDefs}
                    dtiversData={driversData}
                    form={form}
                    orgContext={orgContext}
                    currentAccount={currentAccount}
                    handleUpdateWhStorage={handleUpdateWhStorage}
                    selectedButton={selectedButton}
                    multistopLocationRef={multistopLocationRef}
                    handleExpedite={handleExpedite}
                    actionType={actionType}
                    updateLocData={updateLocData}
                    appointmentStyle={true}
                    msLos={msLos}
                    />
                </Col>
              {/* <ItemsMeasure 
                getDataRef={itemsInfoRef}
                getFieldDecorator={getFieldDecorator}
                currentOrg={currentOrg} 
                accountId={accountId}
                key={`items`}
                form={form}
                /> */}
                <Col className="ms-integrated-card">
              {/* <CreateOrderAccessorial
                accountAccessorial={accountAccessorial} 
                config={config}   
                haveMultipleLocations={haveMultipleLocations}    
                displayComponents={displayComponents}
                getFieldDecorator={getFieldDecorator}
                processingRecords={orderAccessorials}
                updateOrderAccessorials={(orders) => { 
                  console.log("orders",  orders)
                  setOrderAccessorials(orders)}}
                  accountComponentAccessorial={accountComponentAccessorial}
                  drivers ={driversData}
                  /> */}
                <CreateOrderAccessorial
            // getDataRef={accessorialRef.current[index]}
            accountComponentAccessorial={accountComponentAccessorial}
            accountAccessorial={accountAccessorial}
            config={props.config}
            haveMultipleLocations={props.haveMultipleLocations}
            displayComponents={props?.displayComponents || []}
            //title={labelCodeTitle}
            //accRef={accessorialRef}
            drivers={driversData}
            updateOrderAccessorials={setOrderAccessorials}
            processingRecords={orderAccessorials}
            currentOrg={currentOrg}
            accountId={currentAccount.id}
            prevAuthorizedInfo={authorizeDetails}
            actionType={actionType}            
        />
                </Col>
              
              <Col className="ms-integrated-card" style={{marginBottom:"16px"}}>
              <Documents
                getFieldDecorator={getFieldDecorator} 
                currentOrg={currentOrg} 
                accountId={orderDetails.account_id}
                currentOrder={currentOrder}
                getDataRef = {documentsRef}
                typeOfOrder= {currentOrder}
                documents={locObj.documents || []}
                locObj={locObj}
                config={config}
                handleCreatePicsInfo={handleCreatePicsInfo}
                handleRemovePicsInfo={handleRemovePicsInfo}
                actionType={screenMode}
                containerStyle={{ background: "#f7f8fa" }}
                />
                </Col>
              </div>
            </div>
  );
};
export default MultistopOrder;
